import React from 'react';
import { Link } from 'react-router';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { IconWrap } from '../../../components/IconWrap';
import { CiShare1, CiBookmark, CiCircleCheck, CiCircleChevRight } from 'react-icons/ci';
import useTheme from '../../../hooks/useTheme';

export const WhatBCBHDoes: React.FC = () => {
  const { theme } = useTheme();
  const pillars = [
    {
      title: 'Knowledge & Technology Exchange',
      description: 'Facilitating the transfer of technical know-how, best practices, and innovative solutions between Korean and Egyptian companies.',
      icon: <CiShare1 />,
      bullets: [
        'Technical know-how transfer programs',
        'Best practices sharing sessions',
        'Innovation partnership facilitation',
      ],
    },
    {
      title: 'Training & Capacity Building',
      description: 'Organizing training programs, workshops, and capacity-building initiatives to enhance skills and capabilities in both markets.',
      icon: <CiBookmark />,
      bullets: [
        'Skills development workshops',
        'Technology transfer programs',
        'Cross-cultural business training',
      ],
    },
    {
      title: 'Projects, Tenders & Joint Execution',
      description: 'Supporting joint venture formation, tender collaboration, and project execution opportunities between Korean and Egyptian partners.',
      icon: <CiCircleCheck />,
      bullets: [
        'Joint venture formation support',
        'Tender collaboration facilitation',
        'Project execution coordination',
      ],
    },
  ];

  return (
    <Section id="features">
      <h2
        style={{
          fontSize: '34px',
          fontWeight: 700,
          color: theme.text.primary,
          marginBottom: '48px',
          textAlign: 'center',
        }}
        className="sectionTitle"
      >
        What BCBH Does
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
        }}
        className="pillarsGrid"
      >
        {pillars.map((pillar, idx) => (
          <Card key={idx} hoverable style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '64px',
                height: '64px',
                backgroundColor: theme.background.panel,
                borderRadius: theme.borderRadius.r1,
                marginBottom: '20px',
              }}
            >
              <div style={{ fontSize: '48px', color: theme.colors.green.g1 }}>
                {pillar.icon}
              </div>
            </div>
            <h3
              style={{
                fontSize: '22px',
                fontWeight: 600,
                color: theme.text.primary,
                marginBottom: '8px',
              }}
            >
              {pillar.title}
            </h3>
            <p
              style={{
                color: theme.text.muted,
                lineHeight: 1.6,
                marginBottom: '16px',
                fontSize: '15px',
              }}
            >
              {pillar.description}
            </p>
            <div style={{ marginBottom: '20px' }}>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: theme.text.primary,
                  marginBottom: '8px',
                }}
              >
                Includes:
              </div>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px',
                }}
              >
                {pillar.bullets.map((bullet, bulletIdx) => (
                  <li
                    key={bulletIdx}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '8px',
                      fontSize: '14px',
                      color: theme.text.muted,
                    }}
                  >
                    <span style={{ color: theme.colors.green.g1, marginTop: '4px', flexShrink: 0 }}>•</span>
                    {bullet}
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: `1px solid ${theme.colors.line}` }}>
              <Link
                to="/about"
                style={{
                  color: theme.colors.green.g1,
                  textDecoration: 'none',
                  fontSize: '15px',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
                className="learnMoreLink"
              >
                How it works
                <IconWrap icon={<CiCircleChevRight />} size={16} color="primary" />
              </Link>
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
};

